// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1kHDT","actions":"GroupTable_actions__1p8ft","deleteModalFooter":"GroupTable_deleteModalFooter__Rkfqi"};